import { Api as backendApi, } from '@tymia/main-api';
function getApiUrl(path) {
    const frontendHost = window.location.host;
    const host = frontendHost.replace(/^(www\.)/, frontendHost.endsWith('.localhost') ? 'api.' : 'app.');
    const prodHost = host === 'tymia.de' ? 'app.tymia.de' : host;
    return `${window.location.protocol}//${prodHost}${path}`;
}
export const api = backendApi({
    baseUrl: getApiUrl(''),
});
//# sourceMappingURL=Api.js.map